<template>
  <div id="Echartcontent">
    <div class="container-fluid">
      <div class="block-header"></div>

      <!-- Pie charts -->
      <div class="row clearfix gap-2">
        <div class="col-lg-4 col-md-4 col-sm-12 px-0">
          <div class="card">
            <div class="body">
              <v-chart :option="pieChart1" autoresize />
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="card">
            <div class="body">
              <v-chart :option="pieChart2" autoresize />
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12 px-0">
          <div class="card">
            <div class="body">
              <v-chart :option="pieChart3" autoresize />
            </div>
          </div>
        </div>
      </div>

      <!-- Subjects + Facescans + Reports -->
      <div class="row clearfix">
        <div class="col-lg-12 col-md-12 col-sm-12 px-0">
          <div class="card stats-card">
            <div class="body stats-body">
              <div class="stats-vertical">
                <div
                  class="stat-circle"
                  :style="circleStyle('#333D79FF')"
                  aria-label="Total subjects"
                >
                  <div class="stat-value">{{ animatedSubjects }}</div>
                  <div class="stat-label">Subjects</div>
                </div>

                <div
                  class="stat-circle"
                  :style="circleStyle('#5A86FF')"
                  aria-label="Total facescans"
                >
                  <div class="stat-value">{{ animatedFacescans }}</div>
                  <div class="stat-label">Facescans</div>
                </div>

                <div
                  class="stat-circle"
                  :style="circleStyle('#B2A5FF')"
                  aria-label="Total reports"
                >
                  <div class="stat-value">{{ animatedReports }}</div>
                  <div class="stat-label">Reports</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/plugins/echarts";

export default {
  name: "AnalyticalData",
  data() {
    return {
      subjectsCount: 0,
      facescansCount: 0,
      animatedFacescans: 0,
      reportsCount: 0,
      animatedSubjects: 0,
      animatedReports: 0,
      rafIds: { subjects: null, faces: null, reports: null }, 
      pieChart1: {
        color: ["#476EAE", "#333D79FF", "#9AA0A6"],
        title: {
          text: " Genders",
          subtext: "Genders identity",
          x: "center",
          textStyle: { color: "#525252" },
        },
        tooltip: { trigger: "item" },
        legend: {
          orient: "vertical",
          left: "left",
          data: [],
          textStyle: { color: "#525252" },
        },
        series: [
          {
            name: "Subjects",
            type: "pie",
            radius: ["30%", "60%"], 
            center: ["50%", "60%"],
            roseType: "area", 
            minAngle: 12, 
            padAngle: 3, 
            minShowLabelAngle: 1, 
            avoidLabelOverlap: false,
            itemStyle: {
              shadowBlur: 20,
              shadowColor: "rgba(0,0,0,0.18)",
              borderRadius: 6,
            },
            label: { color: "rgba(0,0,0,0.60)" },
            labelLine: {
              smooth: 0.2,
              length: 10,
              length2: 18,
              lineStyle: { color: "rgba(0,0,0,0.35)" },
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: () => Math.random() * 200,
            data: [], 
          },
        ],
      },

      pieChart2: {
        color: ["#48B3AF", "#A7E399", "#9AA0A6"],
        title: {
          text: "Ethnicities",
          subtext: "Ethnic background",
          x: "center",
          textStyle: { color: "#525252" },
        },
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            const full = params.data.fullName || params.name; 
            return `${full}: ${params.value} (${params.percent}%)`;
          },
        },
        legend: {
          orient: "vertical",
          left: "-10px",
          data: [], 
          textStyle: { color: "#525252" },
        },
        series: [
          {
            name: "Subjects",
            type: "pie",
            radius: ["30%", "60%"],
            center: ["50%", "60%"],
            roseType: "area",
            minAngle: 12,
            padAngle: 3,
            minShowLabelAngle: 1,
            avoidLabelOverlap: false,
            itemStyle: {
              shadowBlur: 20,
              shadowColor: "rgba(0,0,0,0.18)",
              borderRadius: 6,
            },
            label: { color: "rgba(0,0,0,0.60)" },
            labelLine: {
              smooth: 0.2,
              length: 10,
              length2: 18,
              lineStyle: { color: "rgba(0,0,0,0.35)" },
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: () => Math.random() * 200,
            data: [],
          },
        ],
      },

      pieChart3: {
        color: ["#d76662", "#b8322e", "#a62d29", "#842421", "#320A6B"],
        title: {
          text: " Age",
          subtext: "Subject age range",
          x: "center",
          textStyle: { color: "#525252" },
        },
        tooltip: { trigger: "item" },
        legend: {
          orient: "vertical",
          left: "left",
          data: [],
          textStyle: { color: "#525252" },
        },
        series: [
          {
            name: "Subjects",
            type: "pie",
            radius: ["30%", "60%"],
            center: ["50%", "60%"],
            roseType: "area",
            minAngle: 12,
            padAngle: 3,
            minShowLabelAngle: 1,
            avoidLabelOverlap: false,
            itemStyle: {
              shadowBlur: 20,
              shadowColor: "rgba(0,0,0,0.18)",
              borderRadius: 6,
            },
            label: { color: "rgba(0,0,0,0.60)" },
            labelLine: {
              smooth: 0.2,
              length: 10,
              length2: 18,
              lineStyle: { color: "rgba(0,0,0,0.35)" },
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: () => Math.random() * 200,
            data: [],
          },
        ],
      },

      patients: [],
      AGE_LABELS: ["0-5", "5-10", "10-15", "15+"],
    };
  },

  mounted() {
    this.refreshAll();
  },

  methods: {
    circleStyle(color) {
      return {
        background: `
          radial-gradient(140% 140% at 30% 30%, ${color} 0%, ${this.fade(
          color,
          0.85
        )} 60%, ${this.fade(color, 0.65)} 100% )
        `,
        boxShadow: `
          0 14px 28px rgba(0,0,0,.18),
          inset 0 10px 18px rgba(255,255,255,.25),
          inset 0 -10px 18px rgba(0,0,0,.12)
        `,
      };
    },

    fade(hexOrRgba, alpha = 0.8) {
      if (/rgba?\(/i.test(hexOrRgba)) {
        return hexOrRgba.replace(/rgba?\(([^)]+)\)/i, (_, parts) => {
          const [r, g, b] = parts
            .split(",")
            .map((s) => +s.trim())
            .slice(0, 3);
          return `rgba(${r},${g},${b},${alpha})`;
        });
      }
      const m = hexOrRgba.replace("#", "");
      const r = parseInt(m.slice(0, 2), 16);
      const g = parseInt(m.slice(2, 4), 16);
      const b = parseInt(m.slice(4, 6), 16);
      return `rgba(${r},${g},${b},${alpha})`;
    },
    async refreshAll() {
      await this.fetchPatients();
      await this.computeTotalsAndAnimate();
    },

    niceMax(n) {
      if (n <= 0) return 1;
      const exp = Math.floor(Math.log10(n));
      const base = Math.pow(10, exp);
      const candidates = [1, 2, 5, 10].map((m) => m * base);
      return candidates.find((c) => c >= n) ?? 10 * base;
    },
    async computeTotalsAndAnimate() {
      // Subjects
      this.subjectsCount = this.patients.length;

      // Reports 
      const fasdBackendURL =
        localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
      const token = localStorage.getItem("userJWtoken");
      let totalReports = 0;
      for (const p of this.patients) {
        const r = await fetch(
          `${fasdBackendURL}/api/fasdReports/underPatientID/${p.id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (r.ok) {
          const data = await r.json();
          totalReports += Array.isArray(data) ? data.length : 0;
        }
      }
      this.reportsCount = totalReports;
      this.facescansCount = await this.fetchFacescansCount();

      // reset displayed values
      this.animatedSubjects = 0;
      this.animatedFacescans = 0;
      this.animatedReports = 0;

      await this.$nextTick();
      this.countUp("animatedSubjects", this.subjectsCount, 1200, "subjects");
      this.countUp("animatedFacescans", this.facescansCount, 1200, "faces");
      this.countUp("animatedReports", this.reportsCount, 1200, "reports");
    },
    async fetchPatients() {
      const fasdBackendURL =
        localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
      const token = localStorage.getItem("userJWtoken");
      const res = await fetch(`${fasdBackendURL}/api/patients`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      this.patients = await res.json();
      this.updateChartsFromPatients();
    },

    async fetchFacescansCount() {
      const fasdBackendURL =
        localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
      const token = localStorage.getItem("userJWtoken");

      const r = await fetch(`${fasdBackendURL}/api/facescans/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const arr = await r.json();
      return Array.isArray(arr) ? arr.length : 0;
    },

    countUp(field, target, durationMs = 1000, key = "generic") {
      if (this.rafIds[key]) cancelAnimationFrame(this.rafIds[key]);

      const startVal = Number(this[field]) || 0;
      const delta = target - startVal;
      if (delta === 0) return;

      const start = performance.now ? performance.now() : Date.now();
      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

      let intervalId = null;
      const step = (nowTs) => {
        const now =
          typeof nowTs === "number"
            ? nowTs
            : performance.now
            ? performance.now()
            : Date.now();
        const p = Math.min(1, (now - start) / durationMs);
        const eased = easeOutCubic(p);
        const val = startVal + delta * eased;
        this[field] =
          target > 0 ? Math.max(1, Math.floor(val)) : Math.round(val);

        if (p < 1) {
          this.rafIds[key] = requestAnimationFrame(step);
        } else {
          if (intervalId) clearInterval(intervalId);
          this[field] = target; 
          this.rafIds[key] = null;
        }
      };
      this.rafIds[key] = requestAnimationFrame(step);
      intervalId = setInterval(step, 33); 
    },
    // Pie charts
    updateChartsFromPatients() {
      const rows = Array.isArray(this.patients) ? this.patients : [];

      // Gender 
      const genderCounts = { Male: 0, Female: 0, Unknown: 0 };
      for (const p of rows) genderCounts[this.normalizeSex(p?.sex)]++;

      const gData = Object.entries(genderCounts)
        .filter(([, v]) => v > 0)
        .map(([name, value]) => ({ name, value }))
        .sort((a, b) => a.value - b.value); // << sort small → large

      this.pieChart1.legend.data = gData.map((d) => d.name);
      this.pieChart1.series[0].data = gData;

      // Ethnicity 
      const ethCounts = {};
      for (const p of rows) {
        const key = this.normalizeEthnicity(p?.ethnicity);
        ethCounts[key] = (ethCounts[key] || 0) + 1;
      }
      const eData = Object.entries(ethCounts)
        .filter(([, v]) => v > 0)
        .map(([name, value]) => ({
          name, 
          value,
          fullName: name === "AA" ? "African-American" : name, 
        }))
        .sort((a, b) => a.value - b.value);
      this.pieChart2.legend.data = eData.map((d) => d.name);
      this.pieChart2.series[0].data = eData;

      // Age 
      const ageCounts = Object.fromEntries(
        [...this.AGE_LABELS, "Unknown"].map((k) => [k, 0])
      );
      for (const p of rows) {
        const age = this.ageFromDOB(p?.dob);
        const bucket = this.bucketAge(age);
        ageCounts[bucket] = (ageCounts[bucket] || 0) + 1;
      }

      const aData = Object.entries(ageCounts)
        .filter(
          ([k, v]) => v > 0 && (k === "Unknown" || this.AGE_LABELS.includes(k))
        )
        .map(([name, value]) => ({ name, value }))
        .sort((a, b) => a.value - b.value);

      const ageLegend = this.AGE_LABELS.filter((l) =>
        aData.some((d) => d.name === l)
      );
      if (aData.some((d) => d.name === "Unknown")) ageLegend.push("Unknown");

      this.pieChart3.legend.data = ageLegend;
      this.pieChart3.series[0].data = aData;
    },

    // mappers
    normalizeSex(sex) {
      const v = (sex ?? "").toString().trim().toLowerCase();
      if (v === "male" || v === "m") return "Male";
      if (v === "female" || v === "f") return "Female";
      return "Unknown";
    },
    normalizeEthnicity(e) {
      const v = (e ?? "").toString().trim().toUpperCase();
      if (v === "CAUC" || v === "CAUCASIAN") return "Caucasian";
      if (v === "CAPEC" || v === "AFRICAN-AMERICAN" || v === "AFRICAN AMERICAN")
        return "AA";
      return "Other/Unknown";
    },
    ageFromDOB(dobStr) {
      if (!dobStr) return null;
      const d = new Date(dobStr);
      if (isNaN(d)) return null;
      const today = new Date();
      let age = today.getFullYear() - d.getFullYear();
      const m = today.getMonth() - d.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age--;
      return age >= 0 ? age : null;
    },
    bucketAge(age) {
      if (age == null) return "Unknown";
      if (age <= 5) return "0-5";
      if (age <= 10) return "5-10";
      if (age <= 15) return "10-15";
      return "15+";
    },
  },
};
</script>

<style scoped>
.card {
  height: 300px;
}
.stats-card {
  height: auto;
}
.stats-body {
  padding: 6px;
}
.chart {
  height: 250px;
  max-width: 100%;
}
.body {
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 10px;
}
.stat-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  place-items: center;
  position: relative;
}
.stat-value {
  font-size: 32px;
  font-weight: 800;
  margin-top: 20px;
  line-height: 1;
  color: #fff;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}
.stats-vertical {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px; 
}
.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
</style>